import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import star from "../../images/star.jpg"
import client from "../../images/client.jpg"
import "./ReviewsBlock.scss";
import { Link } from "gatsby";
const Reviews = (props) => {
    const ReviewsList = props.ReviewsList;
    const wordToNumber = {'ONE': 1, 'TWO': 2, 'THREE': 3, 'FOUR': 4, 'FIVE': 5};
    const starRating = (rating) => {
        var starCont = [];
        for (let i = 0; i < rating; i++) {
            starCont.push(<li><img src={star} alt="rating-img" /> </li>);
        }
        return starCont;
    }
    return (
        <React.Fragment>
            <div className="reviews-block">
                <Container>
                    <Row>
                        <Col>
                            <div className="reviews-box">
                                <ul>
                                    {
                                        starRating(wordToNumber[ReviewsList.starRating])
                                    } 
                                </ul>
                                <p>
                                    {ReviewsList.comment}
                                </p>

                                <div className="client-info">
                                    <div className="client-img">
                                        <img src={ReviewsList?.reviewer?.profilePhotoUrl} alt="reviews" height={'50'} />
                                    </div>
                                    <div className="client-content">
                                        <h4>{ReviewsList?.reviewer?.displayName}</h4>
                                        <span className="time">{ReviewsList.Time}</span>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};
export default Reviews;
